import React from 'react'
import { useNavigate } from 'react-router-dom'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { LayoutDashboard as DashboardIcon } from 'lucide-react'
import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent'

export default function DashboardHubPage() {
  const navigate = useNavigate()

  return (
    <div>
      <HeaderTitleContent>Dashboards</HeaderTitleContent>

      <Grid
        container
        spacing={3}
        justifyContent="center"
        style={{ marginTop: 16, padding: '0 24px' }}
      >
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Card
            elevation={2}
            style={{ borderRadius: 12 }}
          >
            <CardActionArea
              onClick={() => navigate('/main/dashboards/default')}
              style={{ padding: 8 }}
            >
              <CardContent style={{ textAlign: 'center' }}>
                <DashboardIcon
                  size={48}
                  color="#10b981"
                  style={{ marginBottom: 12 }}
                />
                <Typography variant="h6" gutterBottom>
                  Default
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Vue flotte des consommations journalières
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </div>
  )
}
